import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Segments } from "../components/site/Segments";
import { Benefits } from "../components/site/Benefits";
import { VendaSection, ParceiroSection } from "../components/site/LeadSections";
import { About } from "../components/site/About";
import { Testimonials } from "../components/site/Testimonials";
import { Footer } from "../components/site/Footer";
import { WhatsAppFab, CookieBanner } from "../components/site/Floating";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#F7F5F0]" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Segments />
        <Benefits />
        <VendaSection />
        <ParceiroSection />
        <About />
        <Testimonials />
      </main>
      <Footer />
      <WhatsAppFab />
      <CookieBanner />
    </div>
  );
}
